
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.223","height":"29.734"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff","stroke":"#fff","stroke-width":".25"}},[_c('path',{attrs:{"data-name":"Контур 475","d":"M14.772 10.804a.69.69 0 00-.69.69v13.05a.691.691 0 101.381 0v-13.05a.69.69 0 00-.691-.69zm0 0"}}),_c('path',{attrs:{"data-name":"Контур 476","d":"M9.452 10.804a.69.69 0 00-.69.69v13.05a.69.69 0 101.381 0v-13.05a.69.69 0 00-.691-.69zm0 0"}}),_c('path',{attrs:{"data-name":"Контур 477","d":"M2.1 8.902v17.012a3.809 3.809 0 001.013 2.627 3.4 3.4 0 002.467 1.067h13.062a3.4 3.4 0 002.467-1.067 3.809 3.809 0 001.013-2.627V8.902a2.638 2.638 0 00-.677-5.187h-3.533v-.863A2.712 2.712 0 0015.178.126H9.042a2.712 2.712 0 00-2.73 2.726v.863H2.777A2.638 2.638 0 002.1 8.902zm16.542 19.324H5.58a2.187 2.187 0 01-2.1-2.313V8.963h17.262v16.951a2.187 2.187 0 01-2.1 2.312zM7.693 2.852a1.33 1.33 0 011.349-1.346h6.131a1.33 1.33 0 011.353 1.346v.863H7.693zM2.777 5.096h18.67a1.243 1.243 0 110 2.486H2.777a1.243 1.243 0 110-2.486zm0 0"}})])])
          )
        }
      }
    